import Web3 from 'web3';

export const web3 = new Web3();
